import ArticleListPage    from '@/domains/blog/components/ArticleListPage';
import {paginateArticles} from '@/domains/blog/components/Pagination';
import articles           from '@/domains/blog/databases/articles.json';
import authors            from '@/domains/blog/databases/authors.json';
import categories         from '@/domains/blog/databases/categories.json';
import Blur               from '@/domains/marketing/components/Backgrounds/Blur';
import {Container}        from '@/domains/marketing/components/Container';
import PrimaryLayout      from '@/domains/marketing/layouts/PrimaryLayout';
import {useSearchParams}  from 'next/navigation';
import {useRouter}        from 'next/router';
import {useEffect}        from 'react';

export default function Category() {
	const router       = useRouter();
	const searchParams = useSearchParams();

	const categorySlug = router.query.category;
	const category     = categories[categorySlug] ?? null;

	useEffect(() => {
		if (category === null) {
			router.push('/blog');
		}
	}, [
		category,
	]);

	if (category === null) {
		return null;
	}

	const page = searchParams.get('page') ?? 1;

	const paginatedArticles = paginateArticles([
		...articles,
	]
		.filter((article) => {
			return article.category === categorySlug;
		})
		.reverse(), page);

	return (<PrimaryLayout pageTitle={`${category.name} | The Atlas Software Blog`}>
		<Blur className="py-12">
			<Container className="isolate relative">
				<ArticleListPage authors={authors}
				                 categories={categories}
				                 currentCategorySlug={categorySlug}
				                 {...paginatedArticles}
				                 hrefForPage={(page) => {
					                 if (page <= 1) {
						                 return `/blog/category/${category?.slug}`;
					                 } else {
						                 return `/blog/category/${category?.slug}?page=${page}`;
					                 }
				                 }}
				/>
			</Container>
		</Blur>
	</PrimaryLayout>);
}
